<template>
	<div class="mainWrapper products">
		<h1>Products</h1>

		<div class="links">
			<b-button type="is-info"
				><router-link to="/products/export">
					Export Products
				</router-link></b-button
			>
		</div>

		<div class="general-search">
			<div>
				<b-field>
					<b-input v-model="searchBdcode" placeholder="BD CODE" @keyup.native.enter="searchProduct"></b-input>
				</b-field>
			</div>

			<div>
				<b-field>
					<b-input v-model="searchBarcode" placeholder="BARCODE" @keyup.native.enter="searchProduct"></b-input>
				</b-field>
			</div>

			<div>
				<b-field>
					<b-input v-model="searchName" placeholder="NAME" @keyup.native.enter="searchProduct"></b-input>
				</b-field>
			</div>

			<div>
				<b-field>
					<b-input v-model="searchStock" placeholder="QUANTITY (MAX)" @keyup.native.enter="searchProduct"></b-input>
				</b-field>
			</div>

			<div>
				<b-button type="is-info" @click="searchProduct()" icon-left="magnify">Search</b-button>
			</div>
		</div>

		<div class="list" v-if="list">
			<div class="product-lists header">
				<div>BD CODE</div>
				<div>BARCODE</div>
				<div>NAME</div>
				<div>STOCK</div>
				<div>DAMAGED</div>
				<div>EXPIRED</div>
				<div>TESTER</div>
				<div>CREATED DATE</div>
				<div></div>
			</div>

			<div v-for="(item, index) of list" v-bind:key="index" class="product-lists">
				<div>{{ item.product.bd_code }}</div>
				<div>{{ item.product.barcode }}</div>
				<div>{{ item.product.name }}</div>
				<div>
					{{ item.stock }}
					<span class="base-unit">{{
						item.product.packaging && item.product.packaging.base_unit ? item.product.packaging.base_unit : 'single_item'
					}}</span>
				</div>
				<div>{{ item.damaged ? item.damaged : 0 }}</div>
				<div>{{ item.expired ? item.expired : 0 }}</div>
				<div>{{ item.tester ? item.tester : 0 }}</div>
				<div>{{ convertTime(item.createdAt) }}</div>
				<div @click="updateProductPopup(item)" class="hyperlink">
					<b-tooltip label="Stock Adjustment" position="is-top">
						<ios-swap-icon w="32px" h="32px" />
					</b-tooltip>
				</div>
			</div>

			<paginate
				v-model="page"
				:page-count="pageCount"
				:click-handler="pagerClick"
				:prev-text="'prev'"
				:next-text="'next'"
				:container-class="'pagination'"
			>
			</paginate>
		</div>

		<b-modal :active.sync="isProductEditActive" :on-cancel="cancelProductUpdate">
			<div class="product-edit-wrapper" v-if="updatingItem !== null">
				<h3>Updating: {{ updatingItem.product.bd_code }}</h3>

				<h3>Current Stock: {{ updatingItem.stock }}</h3>

				<div class="edit-wrapper">
					<b-radio v-model="updateRadio" name="name" native-value="increase"> <ios-arrow-round-up-icon w="24px" h="24px" /> Increase </b-radio>
					<b-radio v-model="updateRadio" name="name" native-value="decrease"> <ios-arrow-round-down-icon w="24px" h="24px" /> Decrease </b-radio>
				</div>

				<div class="edit-wrapper">
					<b-field>
						<b-input v-model="updateProductQty" placeholder="Quantity" type="number" @keyup.native.enter="updateProduct" required></b-input>
					</b-field>

					<textarea name="description" class="description" placeholder="Description (Required)" v-model="description" />
				</div>

				<div class="edit-button-wrapper">
					<div>
						<b-button type="is-warning" @click="isProductEditActive = false">Cancel</b-button>
					</div>
					<div>
						<b-button type="is-info" @click="updateProduct()">Update</b-button>
					</div>
				</div>
			</div>
		</b-modal>
	</div>
</template>

<script>
export default {
	name: 'Products',
	data: function() {
		return {
			limit: 20, // For pager
			list: null, // Will contain all the list
			pageCount: 1, // For pager
			page: 1, // For pager
			searchName: '', // To search by name
			searchBarcode: '', // To search by barcode
			searchBdcode: '', // To search by BDCode
			searchStock: '', // To filter by stock
			isProductEditActive: false,
			updateProductQty: null,
			updateRadio: null, // To select increase or decrease
			updatingItem: null,
			description: null
		}
	},

	mounted: async function() {
		// Get list of brands
		const data = {
			limit: this.limit,
			populate: ['product']
		}

		const apiGetProducts = await this.$api.getProducts({ data })

		this.pageCount = Math.ceil(apiGetProducts.data.total / this.limit)

		this.list = apiGetProducts.data.list
	},

	methods: {
		// Updating product
		updateProduct: async function() {
			if (this.updateRadio == null || this.updateProductQty == null || this.description == null) {
				this.$swal.fire({
					icon: 'error',
					title: 'Error...',
					text: 'Missing required fields'
				})

				return
			}

			var data = {
				id: this.updatingItem._id,
				description: this.description,
				adjustments: {
					stock: {
						type: this.updateRadio,
						value: this.updateProductQty
					}
				}
			}

			const apiUpdateProduct = await this.$api.updateProduct({ data })

			if (apiUpdateProduct !== undefined) {
				this.updateRadio = null
				this.updateProductQty = null
				this.isProductEditActive = false

				this.updatingItem = null
				this.description = null

				this.searchProduct()
			}
		},

		// When user update the product
		updateProductPopup: function(item) {
			this.updatingItem = item
			this.isProductEditActive = true
		},

		// When user click close the update modal
		cancelProductUpdate: function() {
			this.updatingItem = null
			this.description = null
			this.updateRadio = null
			this.updateProductQty = null
			this.isProductEditActive = false
		},

		// When user clicked on search
		searchProduct: async function() {
			// Calculate how many items to skip

			var data = {
				limit: this.limit,
				populate: ['product']
			}

			if (this.searchName.length > 0 || this.searchBdcode.length > 0 || this.searchBarcode.length > 0) {
				data.products = {}
			}

			if (this.searchName.length > 0) {
				data.products.name = this.searchName
			}

			if (this.searchBdcode.length > 0) {
				data.products.bd_code = this.searchBdcode
			}

			if (this.searchBarcode.length > 0) {
				data.products.barcode = this.searchBarcode
			}

			if (this.searchStock) {
				data.advance_filters = {
					stock: {
						$lte: this.searchStock
					}
				}
			}

			const apiGetProducts = await this.$api.getProducts({ data })

			this.pageCount = Math.ceil(apiGetProducts.data.total / this.limit)

			this.list = apiGetProducts.data.list
		},

		pagerClick: async function(pageNumber) {
			// Calculate how many items to skip
			var skip

			if (pageNumber == 1) {
				skip = 0
			} else {
				skip = (pageNumber - 1) * this.limit
			}

			var data = {
				limit: this.limit,
				populate: ['product'],
				skip
			}

			if (this.searchName.length > 0 || this.searchBdcode.length > 0 || this.searchBarcode.length > 0) {
				data.products = {}
			}

			if (this.searchName.length > 0) {
				data.products.name = this.searchName
			}

			if (this.searchBdcode.length > 0) {
				data.products.bd_code = this.searchBdcode
			}

			if (this.searchBarcode.length > 0) {
				data.products.barcode = this.searchBarcode
			}

			if (this.searchStock) {
				data.advance_filters = {
					stock: {
						$lte: this.searchStock
					}
				}
			}

			const apiGetProducts = await this.$api.getProducts({ data })

			this.pageCount = Math.ceil(apiGetProducts.data.total / this.limit)

			this.list = apiGetProducts.data.list
		},

		// Convert time
		convertTime: function(time) {
			return this.$moment(time).format('DD/MM/YY hh:mm a')
		}
	}
}
</script>

<style scoped>
@import '../styles/Products.css';
</style>
